const stats = [
  { value: '6000+', label: '在架影视' },
  { value: '每日', label: '内容更新' },
  { value: '多线路', label: '流畅播放' },
];

const quickTags = ['科幻', '悬疑', '古装', '都市', '动画', '爱情'];

export default function Hero() {
  return (
    <section
      id="home"
      className="relative pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden bg-gradient-to-b from-background-100 via-background-50 to-background-50"
    >
      <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-accent-100/60 blur-3xl pointer-events-none"></div>
      <div className="absolute top-40 -left-20 w-72 h-72 rounded-full bg-primary-100/50 blur-3xl pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-background-200/80 text-xs md:text-sm text-foreground-700">
              <i className="ri-sparkling-2-line text-accent-600"></i>
              本周新增 28 部影视作品
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-[3.25rem] font-bold text-foreground-950 leading-tight mt-5">
              星辰影院
              <span className="block mt-2 text-2xl md:text-4xl lg:text-[2.5rem] text-primary-600">
                最新电影与热门电视剧，随时在线高清观看
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-5 max-w-xl">
              这里聚合了最新的院线新片与正在热播的电视剧资源，支持在线免费观看，画质高清、更新及时。
              无论你是想追一部新剧，还是回头补几部经典老片，都能快速找到可用的播放源，省去四处搜索的麻烦。
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mt-7">
              <a
                href="#category"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即进入片库
              </a>
              <a
                href="#movies"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-900 border border-background-300/70 text-sm md:text-base font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                看看最新上线
              </a>
            </div>

            <div className="flex flex-wrap gap-2 mt-7">
              {quickTags.map((tag) => (
                <a
                  key={tag}
                  href="#category"
                  className="px-3 py-1.5 rounded-full bg-background-100 text-xs md:text-sm text-secondary-900 hover:bg-secondary-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {tag}
                </a>
              ))}
            </div>

            <div className="grid grid-cols-3 gap-4 mt-9 pt-7 border-t border-background-200/80 max-w-lg">
              {stats.map((s) => (
                <div key={s.label}>
                  <div className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                    {s.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border border-background-200/70 bg-background-100 w-full h-[300px] sm:h-[380px] lg:h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20abstract%20collage%20of%20warm%20amber%20light%20rays%20through%20a%20dark%20cinema%20hall%2C%20deep%20crimson%20velvet%20curtains%20and%20glowing%20film%20reels%2C%20elegant%20minimal%20composition%2C%20rich%20texture%2C%20high%20detail%2C%20no%20text&width=1000&height=920&seq=xc-hero-main&orientation=portrait"
                alt="星辰影院在线观影氛围图"
                title="星辰影院 在线观看 电影 电视剧 高清资源"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-foreground-950/10 to-transparent"></div>

              <div className="absolute left-4 md:left-6 bottom-4 md:bottom-6 right-4">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse"></span>
                  正在热播
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mt-2">
                  雾都迷案 · 更新至 24 集
                </h3>
                <p className="text-xs md:text-sm text-background-100/90 mt-1">
                  悬疑 · 犯罪　本周一、三、五 20:00 更新
                </p>
              </div>
            </div>

            <div className="absolute -left-3 md:-left-6 top-8 bg-background-50 rounded-xl px-4 py-3 border border-background-200/80 animate-float-y">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className="ri-star-smile-line text-lg"></i>
                </span>
                <div>
                  <div className="font-heading text-sm font-bold text-foreground-950">9.1 高分</div>
                  <div className="text-[11px] text-foreground-500">编辑推荐 · 山海图志</div>
                </div>
              </div>
            </div>

            <div className="absolute -right-2 md:-right-5 bottom-16 bg-background-50 rounded-xl px-4 py-3 border border-background-200/80">
              <div className="text-[11px] text-foreground-500">今日更新</div>
              <div className="font-heading text-lg font-bold text-primary-600">6 部</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}